import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';
import { filterI18nProps } from '../../utils/styledComponentsUtils';

interface IIconStyleProps {
  color: string;
}

const IconStyle = styled.span<IIconStyleProps>`
  color: ${(props) => props.color};
  user-select: none;
`;

interface IProps extends HTMLAttributes<HTMLSpanElement> {
  icon: string
  color: string
}

// TODO: remove this now that we have material ui icons package
const Icon: React.FC<IProps> = ({ icon, color, ...rest }: IProps) => (
  <IconStyle {...filterI18nProps(rest)} color={color} className="material-icons">
    {icon}
  </IconStyle>
);

export default Icon;
